import React from 'react';
import SEOHead from '../components/SEOHead';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Integration from '../components/Integration';
import HowItWorks from '../components/HowItWorks';
import DashboardPreview from '../components/DashboardPreview';
import Pricing from '../components/Pricing';
import Contact from '../components/Contact';
import FinalCTA from '../components/FinalCTA';
import Footer from '../components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <SEOHead />
      <Header />
      <main>
        <Hero />
        <HowItWorks />
        <Features />
        <Integration />
        <DashboardPreview />
        <Pricing />
        <Contact />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
